/**
 * Created by jiachenpan on 16/11/18.
 */

const isLang =  whatLang()

const LANG = {
  'en': {
    days: ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'],
    year: '-',
    month: '-',
    day: '',
    ago: 'a moment ago',
    monthAgo:'months ago',
    dayAgo: 'days ago',
    hourAgo: 'hours ago',
    minuteAgo: 'minutes ago',
    weekAgo: 'weeks ago',
  },
  'zh': {
    days: ['一', '二', '三', '四', '五', '六', '日'],
    year: '年',
    month: '月',
    day: '日',
    ago: '刚刚',
    monthAgo:'月前',
    dayAgo: '天前',
    hourAgo: '小时前',
    minuteAgo: '分钟前',
    weekAgo: '周前',
  },
}

export function whatLang() {
  let LOACLE_LANG = navigator.language || navigator.userLanguage 
  LOACLE_LANG = LOACLE_LANG.substr(0, 2)
  let lang = ''
  if (LOACLE_LANG === 'zh') {
    lang = 'zh'
  } else {
    lang = 'en'
  }
  return lang
}


export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((`${time}`).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return LANG[isLang]['days'][value - 1]
    if (result.length > 0 && value < 10) {
      value = `0${value}`
    }
    return value || 0
  })
  return time_str
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()
  const diff = (now - d) / 1000

  if (diff < 30) {
    return `${LANG[isLang]['ago']}`
  } else if (diff < 3600) { // less 1 hour
    return `${Math.ceil(diff / 60)}${LANG[isLang]['minuteAgo']}`
  } else if (diff < 3600 * 24) {
    return `${Math.ceil(diff / 3600)}${LANG[isLang]['hourAgo']}`
  } else if (diff < 3600 * 24 * 7) {
    return `${Math.ceil(diff / 3600 / 24)}${LANG[isLang]['dayAgo']}`
  }
  const hour = d.getHours()
  const min = d.getMinutes()

  let hs = hour
  if (hour >= 0 && hour < 10) {
    hs = `0${hour}`
  }
  let ms = min
  if (min >= 0 && min < 10) {
    ms = `0${min}`
  }

  return `${d.getFullYear()}${LANG[isLang]['year']}${d.getMonth() + 1}${LANG[isLang]['month']}${d.getDate()}${LANG[isLang]['day']} ${hs}:${ms}`
}
export function getTime(time, option) {
  time = +time *1000;
  const d = new Date(time);
  const year = d.getFullYear();
  return `${year}${LANG[isLang]['year']}${d.getMonth() + 1}${LANG[isLang]['month']}${d.getDate()}${LANG[isLang]['day']}`
}

export function getDateDiff(dateTimeStamp) {
  if (typeof dateTimeStamp === 'string') {
    dateTimeStamp = new Date(dateTimeStamp).getTime()
  }

  const minute = 1000 * 60
  const hour = minute * 60
  const day = hour * 24
  const halfamonth = day * 15
  const month = day * 30
  const now = new Date().getTime()
  const diffValue = now - dateTimeStamp * 1000
  let result = `${LANG[isLang]['ago']}`
  if (diffValue < 0) {
    return result
  }
  const monthC = diffValue / month
  const weekC = diffValue / (7 * day)
  const dayC = diffValue / day
  const hourC = diffValue / hour
  const minC = diffValue / minute
  if (monthC >= 1) {
    result = `${parseInt(monthC)}${LANG[isLang]['monthAgo']}`
  } else if (weekC >= 1) {
    result = `${parseInt(weekC)}${LANG[isLang]['weekAgo']}`
  } else if (dayC >= 1) {
    result = `${parseInt(dayC)}${LANG[isLang]['dayAgo']}`
  } else if (hourC >= 1) {
    result = `${parseInt(hourC)}${LANG[isLang]['hourAgo']}`
  } else if (minC >= 1) {
    result = `${parseInt(minC)}${LANG[isLang]['minuteAgo']}`
  } else { result = `${LANG[isLang]['ago']}` }
  return result
}



// WEBPACK FOOTER //
// ./src/utils/index.js